
import "./styles/AllDashboard.css";
import "./styles/dashboard.css";
import "./styles/layout.css";
import "./styles/navbar.css";
import "./styles/sales.css";
import "./styles/upload.css";
import Kyc from "./pages/Kyc.jsx";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RecoilRoot } from "recoil";

import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import AuthSuccess from "./components/AuthSuccess";
import AuthError from "./components/AuthError";
import ProtectedRoute from "./pages/ProtectedRoute";
import ReportsType from "./pages/ReportsType";
import Sales from "./pages/Sales";
import Signup from "./pages/SignUp";
import Subscription from "./pages/Subscription";
import Statement from "./pages/Statement";
import UploadReports from "./pages/UploadReports";
import Report from "./pages/Reports";
import AccountProfile from "./pages/AccountProfile";
import Invoice from "./pages/Invoice";

import MarketingDashboard from "./pages/MarketingDashboard";
import SalesDashboard from "./pages/SalesDashboard";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import FInnanceDashboard from "./pages/FInnanceDashboard";
import HealthandSafetyDashboard from "./pages/HealthandSafetyDashboard";
import LearningDashboard from "./pages/LearningDashboard";
import LogisticDashboard from "./pages/LogisticDashboard";
import SalesDashboard2 from "./pages/SalesDashboard2";
import InventoryDashboard from "./pages/InventoryDashboard";
import LedgerSetup from "./pages/LedgerSetup";
import Journal from "./pages/Journal";
import Professional from "./pages/Professional.jsx";
import AccountingFirm from "./pages/AccountingFirm.jsx";

import KycDetails from "./pages/KycDetails.jsx";

import Invoicemanagement from "./pages/Invoicemanagement.jsx";
import Compliances from "./pages/Compliances.jsx";
import { InputProvider } from "./context/InputProvider";
import UploadFiles from "./pages/UploadFiles";
import SuperAdmin from "./pages/SuperAdmin.jsx";
import CaTask from "./pages/CaTask.jsx";
import KycForm from "./pages/KycForm.jsx";
import Nopage from "./pages/Nopage.jsx";
import CustomerInvoice from "./pages/CustomerInvoice.jsx";
import CustomerInvoiceProfile from "./pages/CustomerInvoiceProfile.jsx";
import Vanders from "./pages/Vanders.jsx";
import InvoiceProducts from "./pages/InvoiceProducts.jsx";

import InvoiceCustomers from "./pages/InvoiceCustomers.jsx";
import InvoicePurchaseHistory from "./pages/InvoicePurchaseHistory";
import InvoiceInventory from "./pages/InvoiceInventory";
import InvoiceReports from "./pages/InvoiceReports";
import InvoiceDocuments from "./pages/InvoiceDocuments.jsx";
import UserDocument from "./pages/UserDocument.jsx";
import Cadashboard from "./pages/Cadashboard.jsx";
import CaQuickActions from "./pages/CaquickAction.jsx";
import Caclientdirectory from "./pages/Caclientdirectory.jsx";

import Caclientresources from "./pages/CAclientresources.jsx";
import TaskCalendar from "./pages/Cataskcalender.jsx";
import Cadeadlinealert from "./pages/Cadeadlinealert.jsx";
import Capreodicaudits from "./pages/Capreodicaudits.jsx";
import ComplianceTracking from "./pages/Cacomplicetracking.jsx";
import Taskapprovalmanagement from "./pages/Taskapprovalmanagement.jsx";
import Cafiletracking from "./pages/Cafiletracking.jsx";
import Cataskapprovalmanagement from "./pages/Cataskapprovalmanagement.jsx";
import Cadocumentupload from "./pages/CAdocumentupload.jsx";
import Cafilelifecycle from "./pages/Cafilelifecycle.jsx";
import Careviewworkflow from "./pages/Careviewworkflow.jsx";
import CaReportPerformance from "./pages/CaReportPerformance.jsx";
import CadetailReview from "./pages/CadetailReview.jsx";
import CaAdminTeamManagement from "./pages/CaAdminTeamManagement.jsx";
import AccessControlPage from "./pages/CaAccessControl.jsx";
import Legal from "./pages/Legal.jsx";
import LegalActiveCases from "./pages/LegalActiveCases.jsx";
import LegalResearch from "./pages/LegalResearch.jsx";

import LegalCaseTracking from "./pages/LegalCaseTracking.jsx";
import LegalCaseTimeline from "./pages/LegalCaseTimeline.jsx";
import LegalPerformance from "./pages/LegalPerformance.jsx";
import LegalAnaytics from "./pages/LegalAnaytics.jsx";
import GstPortal from "./pages/GstPortal.jsx";
import GSTRONE from "./pages/GSTRONE.jsx";
import GstTwo from "./pages/GstTwo.jsx";
import Gstthree from "./pages/Gstthree.jsx";
import GstAnnual from "./pages/GstAnnual.jsx";
import GstPaymentTracking from "./pages/GstPaymentTracking.jsx";
import GstclientDirectory from "./pages/GstclientDirectory.jsx";

import GstClientTask from "./pages/GstClientTask.jsx";
import GstActiveTask from "./pages/GstActiveTask.jsx";
import GstAssignmentManagement from "./pages/GstAssignmentManagement.jsx";
import GstTaskCalender from "./pages/GstTaskCalender.jsx";
import GstcompliceChecklist from "./pages/GstcompliceChecklist.jsx";
import Gstpendingcomplice from "./pages/Gstpendingcomplice.jsx";
import Gstcomplicedeadline from "./pages/Gstcomplicedeadline.jsx";
import GstTaxReport from "./pages/GstTaxReport.jsx";
import GSTComplianceReport from "./pages/GstcompliceReport.jsx";
import GstclientReports from "./pages/GstclientReports.jsx";
import RegulatoryComplice from "./pages/RegulatoryComplice.jsx";
import CompliceAudit from "./pages/CompliceAudit.jsx";
import ComplicePolicy from "./pages/ComplicePolicy.jsx";
import CompliceRiskIdentification from "./pages/CompliceRiskIdentification.jsx";
import CompliceRiskAnalysis from "./pages/CompliceRiskAnalysis.jsx";
import CompliceMitigationStrategies from "./pages/CompliceMitigationStrategies.jsx";

import CompliceDocumentApproval from "./pages/CompliceDocumentApproval.jsx";
import CompliceStakeholderManagement from "./pages/CompliceStakeholderManagement.jsx";
import CompliceRelationshipManagement from "./pages/CompliceRelationshipManagement.jsx";
import CompliceReport from "./pages/CompliceReport.jsx";
import CompliceAuditTrails from "./pages/CompliceAuditTrails.jsx";
import Ewaybills from "./pages/Ewaybills.jsx";
import EsignDoucumnet from "./pages/Esign.jsx";
import EsignDashboard from "./pages/EsignDashboard.jsx";
import EsignSignature from "./pages/EsignSignature.jsx";
import EsignWorkplaceManagement from "./pages/EsignWorkplaceManagement.jsx";

import EsignHistory from "./pages/EsignHistory.jsx";
import Csdashboard from "./pages/Csdashboard.jsx";
import CsboardMeeting from "./pages/CsboardMeeting.jsx";

import CsCalenderPage from "./pages/CsCalenderPage.jsx";
import CsReport from "./pages/CsReport.jsx";
import NewCase from "./pages/NewCase.jsx";
import CaTasks from "./pages/CaTasks.jsx";
import TaxPreparation from "./pages/TaxPreparation.jsx";
import axios from "axios";
import CaDocumentCenter from "./pages/CaDocumentCenter.jsx";
import KycManagement from "./pages/KycManagement.jsx";
import Unauthorized from "./pages/Unauthorized.jsx";


import ClientCompanies from "./pages/ClientCompanies.jsx";
import ClientTasks from "./pages/ClientTasks.jsx";
import ClientSelection from "./pages/ClientSelection.jsx";
import UserTasks from "./pages/UserTasks.jsx";
import CashFlowDashboard from "./pages/ChartsPages/CashFlow.jsx";
import InvestmentScheduleDashboard from "./pages/ChartsPages/InvestmentSedule.jsx";
import PartnersCapital from "./pages/ChartsPages/PartnersCapital.jsx";
import Profit_Loss from "./pages/ChartsPages/Profit_Loss.jsx";
import BalanceSheet from "./pages/ChartsPages/BalanceSheet.jsx";
import SubUserCreation from "./pages/SubUserCreation.jsx";
import EmployeeAdminDashboard from "./pages/EmployeeAdminDashboard.jsx";
import SubUserManagement from "./pages/SubUserManagement.jsx";
import SubUserEdit from "./pages/SubUserEdit.jsx";
import SubUserPasswordReset from "./pages/SubUserPasswordReset.jsx";
import SubUserUpdate from "./pages/SubUserUpdate.jsx";
import SubUserPermissionsPage from "./pages/SubUserPermissionsPage.jsx";
import Chatbot from "./components/Chatbot.jsx";
import { useLocation } from "react-router-dom";

import OurVision from "./pages/OurVision.jsx";
import Services from "./pages/Services.jsx";
import SubscriptionPlan from "./pages/SubscriptionPlan.jsx";
import ContactUs from "./pages/ContactUs.jsx";
import Privacy from "./pages/privacy.jsx";
import Refund from "./pages/refund.jsx";
import Terms from "./pages/terms.jsx";
import EinvocieInfo from "./pages/EinvocieInfo.jsx";
import GstInfo from "./pages/GstInfo.jsx";
import EsignInfo from "./pages/EsignInfo.jsx";
import ChatBotInfo from "./pages/ChatBotInfo.jsx";
import ReportGenerationInfo from "./pages/ReportGenerationInfo.jsx";
import IntrectiveChartInfo from "./pages/IntrectiveChartInfo.jsx";
import CloudStorageInfo from "./pages/CloudStorageInfo.jsx";
import TaskMangerInfo from "./pages/TaskMaangerInfo.jsx";
import JournalCreationInfo from "./pages/JournalCreationInfo.jsx";
import ComplianceInfo from "./pages/ComplianceInfo.jsx";
import Blog from "./pages/Blog.jsx";
import CaseStudy from "./pages/CaseStudy.jsx";
import AutomationInfo from "./pages/AutomationInfo.jsx";
import AnalyticsInfo from "./pages/AnalyticsInfo.jsx";
import IntegrationInfo from "./pages/IntegrationInfo.jsx";
import SecurityInfo from "./pages/SecurityInfo.jsx";
import MsmeInfo from "./pages/MsmeInfo.jsx";
import StartupInfo from "./pages/StartupInfo.jsx";
import ConsultingFirms from "./pages/ConsultingFirms.jsx";
import AuthRedirect from "./components/AuthRedirect.jsx";
import MyBookings from "./pages/MyBookings.jsx";
import MyWallate from "./pages/MyWallate.jsx";
import AcceptConnectionPage from "./pages/AcceptConnection.jsx";
import KycShare from "./pages/kycShare.jsx";
import Sharedkycpage from "./pages/Sharedkycpage.jsx";

const ChatbotWrapper = ({ dashboardData, onDashboardUpdate }) => {
  const location = useLocation();

  const hideChatbotRoutes = [
    "/login",
    "/signup",
    "/auth-success",
    "/auth-error",
  ];

  if (hideChatbotRoutes.includes(location.pathname)) {
    return null;
  }

  return (
    <Chatbot
      dashboardData={dashboardData}
      onDashboardUpdate={onDashboardUpdate}
    />
  );
};

axios.defaults.withCredentials = true;

const App = () => {
  return (
    <RecoilRoot>
      <BrowserRouter>
        <InputProvider>
          <Routes>
            <Route path="/" element={<AuthRedirect />} />
            <Route path="/services/e-invoice" element={<EinvocieInfo />} />
            <Route path="/services/gst" element={<GstInfo />} />
            <Route path="/services/esign" element={<EsignInfo />} />
            <Route path="/services/chatbot" element={<ChatBotInfo />} />
            <Route path="/services/chatbot" element={<ChatBotInfo />} />
            <Route path="/kycShare" element={<KycShare/>} />
            <Route path="/kyc/view/:token" element={<Sharedkycpage />} />
            
            <Route
              path="/accept-connection/:token"
              element={<AcceptConnectionPage />}
            />
            

            <Route
              path="/services/reports"
              element={<ReportGenerationInfo />}
            />
            <Route path="/services/charts" element={<IntrectiveChartInfo />} />
            <Route
              path="/services/cloud-storage"
              element={<CloudStorageInfo />}
            />
            <Route path="/services/task-manager" element={<TaskMangerInfo />} />
            <Route
              path="/services/journal-creation"
              element={<JournalCreationInfo />}
            />
            <Route path="/services/compliances" element={<ComplianceInfo />} />
            <Route path="/resources/blog" element={<Blog />} />
            <Route path="/resources/case-studies" element={<CaseStudy />} />
            <Route path="/features/automation" element={<AutomationInfo />} />

            <Route path="/features/analytics" element={<AnalyticsInfo />} />
            <Route path="/features/integration" element={<IntegrationInfo />} />
            <Route path="/features/Security" element={<SecurityInfo />} />
            <Route path="/industry/msme" element={<MsmeInfo />} />
            <Route path="/industry/Startup" element={<StartupInfo />} />
            <Route path="/industry/consulting" element={<ConsultingFirms />} />

            <Route path="/OurVision" element={<OurVision />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/SubscriptionPlan" element={<SubscriptionPlan />} />
            <Route path="/ContactUs" element={<ContactUs />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund-policy" element={<Refund />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth-success" element={<AuthSuccess />} />
            <Route path="/auth-error" element={<AuthError />} />
            <Route path="/Unauthorized" element={<Unauthorized />} />

            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/superadmin" element={<SuperAdmin />} />
            </Route>

            <Route element={<ProtectedRoute allowedRoles={["cs", "admin"]} />}>
              <Route path="/cs/ClientSelection" element={<ClientSelection />} />
             
              <Route path="/cs/ClientTasks" element={<ClientTasks />} />
              <Route path="/cs/ClientCompanies" element={<ClientCompanies />} />
              <Route path="/cs/SubUserCreation" element={<SubUserCreation />} />

              <Route
                path="/cs/SubUserManagement"
                element={<SubUserManagement />}
              />
              <Route path="/cs/sub-user/edit/:id" element={<SubUserEdit />} />
              <Route
                path="/cs/sub-user/reset-password/:id"
                element={<SubUserPasswordReset />}
              />
              <Route
                path="/cs/sub-user/update/:id"
                element={<SubUserUpdate />}
              />
              <Route
                path="/cs/sub-user/permissions/:id"
                element={<SubUserPermissionsPage />}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["ca", "admin"]} />}>
              <Route path="/ca/ClientSelection" element={<ClientSelection />} />
              
              <Route path="/ca/ClientTasks" element={<ClientTasks />} />
              <Route path="/ca/ClientCompanies" element={<ClientCompanies />} />
              <Route path="/ca/SubUserCreation" element={<SubUserCreation />} />
              <Route
                path="/ca/SubUserManagement"
                element={<SubUserManagement />}
              />
              <Route
                path="/ca/sub-user/update/:id"
                element={<SubUserUpdate />}
              />
              <Route
                path="/ca/sub-user/permissions/:id"
                element={<SubUserPermissionsPage />}
              />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoles={["Legal", "admin"]} />}
            >
              <Route
                path="/Legal/ClientSelection"
                element={<ClientSelection />}
              />
              
              <Route path="/Legal/ClientTasks" element={<ClientTasks />} />
              <Route
                path="/Legal/sub-user/update/:id"
                element={<SubUserUpdate />}
              />
              <Route
                path="/Legal/sub-user/permissions/:id"
                element={<SubUserPermissionsPage />}
              />
              <Route
                path="/Legal/SubUserManagement"
                element={<SubUserManagement />}
              />

              <Route
                path="/Legal/SubUserCreation"
                element={<SubUserCreation />}
              />
              <Route
                path="/Legal/ClientCompanies"
                element={<ClientCompanies />}
              />
            </Route>
            <Route
              element={<ProtectedRoute allowedRoles={["employee", "admin"]} />}
            >
              <Route
                path="/employee/sub-user/update/:id"
                element={<SubUserUpdate />}
              />
              <Route
                path="/employee/sub-user/permissions/:id"
                element={<SubUserPermissionsPage />}
              />
              <Route
                path="/employee/ClientSelection"
                element={<ClientSelection />}
              />
              
              <Route path="/employee/ClientTasks" element={<ClientTasks />} />
              <Route
                path="/employee/SubUserCreation"
                element={<SubUserCreation />}
              />
              <Route
                path="/employee/ClientCompanies"
                element={<ClientCompanies />}
              />
            </Route>

            <Route
              element={
                <ProtectedRoute
                  allowedRoles={["admin", "user", "ca", "cs", "employee"]}
                />
              }
            >
              <Route
              path="/accept-connection/:token"
              element={<AcceptConnectionPage />}
            />
              <Route path="/UserTasks" element={<UserTasks />} />
              <Route path="/MyBookings" element={<MyBookings />} />
              <Route path="/MyWallate" element={<MyWallate />} />
              <Route
                path="/EmployeeAdminDashboard"
                element={<EmployeeAdminDashboard />}
              />
              <Route
                path="/CashFlowDashboard"
                element={<CashFlowDashboard />}
              />
              <Route
                path="/InvestmentScheduleDashboard"
                element={<InvestmentScheduleDashboard />}
              />
              <Route path="/PartnersCapital" element={<PartnersCapital />} />
              <Route path="/Profir_Loss" element={<Profit_Loss />} />
              <Route path="/BalanceSheet" element={<BalanceSheet />} />
              <Route
                path="/CashFlowDashboard"
                element={<CashFlowDashboard />}
              />
              <Route path="/ClientSelection" element={<ClientSelection />} />
            
              <Route path="/ClientTasks" element={<ClientTasks />} />
              <Route path="/ClientCompanies" element={<ClientCompanies />} />
              <Route path="/KycManagement" element={<KycManagement />} />
              <Route path="/Cadashboard" element={<Cadashboard />} />
              <Route path="/CaQuickActions" element={<CaQuickActions />} />
              <Route
                path="/Caclientdirectory"
                element={<Caclientdirectory />}
              />

              <Route
                path="/Caclientresources"
                element={<Caclientresources />}
              />
              <Route path="/Cataskcalender" element={<TaskCalendar />} />
              <Route path="/CaDocumentCenter" element={<CaDocumentCenter />} />
              <Route path="/CaTaxPrepatation" element={<TaxPreparation />} />
              <Route path="/Cadeadlinealert" element={<Cadeadlinealert />} />
              <Route path="/Capreodicaudits" element={<Capreodicaudits />} />
              <Route
                path="/ComplianceTracking"
                element={<ComplianceTracking />}
              />
              <Route path="/TaskFlow" element={<Taskapprovalmanagement />} />
              <Route path="/Cafiletracking" element={<Cafiletracking />} />
              <Route
                path="/Cataskapprovalmanagement"
                element={<Cataskapprovalmanagement />}
              />
              <Route path="/CaTasks" element={<CaTasks />} />
              <Route path="/Cadocumentupload" element={<Cadocumentupload />} />
              
              <Route path="/careviewworkflow" element={<Careviewworkflow />} />
              <Route path="/cafilelifecycle" element={<Cafilelifecycle />} />
              <Route
                path="/CaReportPerformance"
                element={<CaReportPerformance />}
              />
              <Route path="/CadetailReview" element={<CadetailReview />} />
              <Route
                path="/CaAdminTeamManagement"
                element={<CaAdminTeamManagement />}
              />

              <Route path="/Dashboard" element={<Dashboard />} />
              <Route path="/subscription" element={<Subscription />} />
              <Route path="/dashboard/:id" element={<ReportsType />} />
              <Route path="/dashboard/:id/sales/:id" element={<Sales />} />
              <Route path="/upload" element={<UploadReports />} />
              <Route path="/statement" element={<Statement />} />
              <Route path="/report" element={<Report />} />
              <Route
                path="/MarketingDashboard"
                element={<MarketingDashboard />}
              />
              <Route path="/salesDashboard" element={<SalesDashboard />} />
              <Route path="/salesDashboard2" element={<SalesDashboard2 />} />
              <Route
                path="/employeeDashboard"
                element={<EmployeeDashboard />}
              />
              <Route
                path="/FinnanceDashboard"
                element={<FInnanceDashboard />}
              />
              <Route path="/accountprofile" element={<AccountProfile />} />
              <Route path="/invoice" element={<Invoice />} />
              <Route path="/ledgersetup" element={<LedgerSetup />} />
              <Route path="/journalposting" element={<Journal />} />
              <Route path="/bankstatement" element={<Report />} />
              <Route
                path="/healthandwellness"
                element={<HealthandSafetyDashboard />}
              />
              <Route path="/logistic" element={<LogisticDashboard />} />
              <Route path="/learning" element={<LearningDashboard />} />
              <Route path="/inventory" element={<InventoryDashboard />} />
              <Route path="UploadFiles" element={<UploadFiles />} />
              <Route path="/kyc" element={<Kyc />} />

              <Route path="/professional" element={<Professional />} />
              <Route path="/accountingfirm" element={<AccountingFirm />} />

              <Route path="/caportal" element={<CaTask />} />
              <Route path="/kycform" element={<KycForm />} />
              <Route path="/KycDetails" element={<KycDetails />} />
              <Route
                path="/invoicemanagement"
                element={<Invoicemanagement />}
              />
              <Route path="/compliance" element={<Compliances />} />
              <Route
                path="/CustomerInvoiceProfile"
                element={<CustomerInvoiceProfile />}
              />
              <Route path="/CustomerInvoice" element={<CustomerInvoice />} />
              <Route path="/InvoiceProducts" element={<InvoiceProducts />} />
              <Route path="/InvoiceCustomers" element={<InvoiceCustomers />} />
              <Route
                path="/InvoicePurchaseHistory"
                element={<InvoicePurchaseHistory />}
              />

              <Route
                path="/InventoryManagement"
                element={<InvoiceInventory />}
              />
              <Route path="/Vanders" element={<Vanders />} />
              <Route path="/InvoiceReports" element={<InvoiceReports />} />
              <Route path="/invoiceDocuments" element={<InvoiceDocuments />} />
              <Route path="/userDocument" element={<UserDocument />} />

              <Route
                path="/AccessControlPage"
                element={<AccessControlPage />}
              />
              <Route path="/Legal" element={<Legal />} />
              <Route path="/NewCase" element={<NewCase />} />
              <Route path="/LegalActiveCases" element={<LegalActiveCases />} />
              <Route path="/LegalResearch" element={<LegalResearch />} />

              <Route
                path="/LegalCaseTracking"
                element={<LegalCaseTracking />}
              />
              <Route
                path="/LegalCaseTimeline"
                element={<LegalCaseTimeline />}
              />
              <Route path="/LegalPerformance" element={<LegalPerformance />} />
              <Route path="/LegalAnaytics" element={<LegalAnaytics />} />
              <Route path="/GstPortal" element={<GstPortal />} />
              <Route path="/Gstrone" element={<GSTRONE />} />
              <Route path="/GstTwo" element={<GstTwo />} />
              <Route path="/Gstthree" element={<Gstthree />} />
              <Route path="/Gstthree" element={<Gstthree />} />
              <Route path="/GstAnnual" element={<GstAnnual />} />
              <Route
                path="/GstPaymentTracking"
                element={<GstPaymentTracking />}
              />
              <Route
                path="/GstclientDirectory"
                element={<GstclientDirectory />}
              />

              <Route path="/GstClientTask" element={<GstClientTask />} />
              <Route path="/GstActiveTask" element={<GstActiveTask />} />
              <Route
                path="/GstAssignmentManagement"
                element={<GstAssignmentManagement />}
              />
              <Route path="/GstTaskCalender" element={<GstTaskCalender />} />
              <Route
                path="/GstcompliceChecklist"
                element={<GstcompliceChecklist />}
              />
              <Route
                path="/Gstpendingcomplice"
                element={<Gstpendingcomplice />}
              />
              <Route
                path="/Gstcomplicedeadline"
                element={<Gstcomplicedeadline />}
              />
              <Route path="/GstTaxReport" element={<GstTaxReport />} />
              <Route
                path="/GSTComplianceReport"
                element={<GSTComplianceReport />}
              />
              <Route path="/GstclientReports" element={<GstclientReports />} />
              <Route
                path="/RegulatoryComplice"
                element={<RegulatoryComplice />}
              />
              <Route path="/CompliceAudit" element={<CompliceAudit />} />
              <Route path="/ComplicePolicy" element={<ComplicePolicy />} />
              <Route
                path="/CompliceRiskIdentification"
                element={<CompliceRiskIdentification />}
              />
              <Route
                path="/CompliceRiskAnalysis"
                element={<CompliceRiskAnalysis />}
              />
              <Route
                path="/CompliceMitigationStrategies"
                element={<CompliceMitigationStrategies />}
              />

              <Route
                path="/CompliceDocumentApproval"
                element={<CompliceDocumentApproval />}
              />
              <Route
                path="/CompliceStakeholderManagement"
                element={<CompliceStakeholderManagement />}
              />
              <Route
                path="/CompliceStakeholderManagement"
                element={<CompliceStakeholderManagement />}
              />
              <Route
                path="/CompliceRelationshipManagement"
                element={<CompliceRelationshipManagement />}
              />
              <Route path="/CompliceReport" element={<CompliceReport />} />
              <Route
                path="/CompliceAuditTrails"
                element={<CompliceAuditTrails />}
              />
              <Route path="/Ewaybills" element={<Ewaybills />} />
              <Route path="/EsignDocument" element={<EsignDoucumnet />} />
              <Route path="/EsignDashboard" element={<EsignDashboard />} />
              <Route path="/EsignSignature" element={<EsignSignature />} />
              <Route
                path="/EsignWorkplaceManagement"
                element={<EsignWorkplaceManagement />}
              />

              <Route path="/EsignHistory" element={<EsignHistory />} />
              <Route path="/csdashboard" element={<Csdashboard />} />
              <Route path="/CsboardMeeting" element={<CsboardMeeting />} />

              <Route path="/CsCalenderPage" element={<CsCalenderPage />} />
              <Route path="/CsReport" element={<CsReport />} />

              <Route path="*" element={<Nopage />} />
            </Route>
          </Routes>
          <ChatbotWrapper />
        </InputProvider>
      </BrowserRouter>
    </RecoilRoot>
  );
};

export default App;
